export const version = '2.21.51';
//# sourceMappingURL=version.js.map